module.exports = __webpack_public_path__ + "static/media/2011-dan-manfred-raphi-anton.80a73c19.jpg";